import type { ReactNode } from 'react';

import { use } from 'react';

import { getTestProps } from '../../../../lib/helpers';

import PopoverComponent from '../../../Popover/Popover';
import { TopbarContext } from '../../Topbar';
import TopbarButton from './TopbarButton';

interface TopbarActionMenuProps {
  /**
   * Action buttons
   */
  children?: ReactNode;
  /**
   * If button is disabled
   */
  disabled?: boolean;
}

const TopbarActionMenu = ({
  children,
  disabled = false,
  ...props
}: TopbarActionMenuProps) => {
  const { testId } = use(TopbarContext);

  const filteredChildren = (
    Array.isArray(children) ? children : [children]
  )?.filter((child) => !!child);

  if (!filteredChildren?.length) return null;

  return (
    <PopoverComponent
      popoverPanelAnchorTo="bottom end"
      additionalPopoverPanelClasses={
        'z-30 border-blue dark:border-blue overflow-visible'
      }
      content={children}
      popoverButton={
        <TopbarButton
          as="div"
          label="..."
          buttonColor="blueBordered"
          additionalClasses="px-2"
          disabled={disabled}
          {...getTestProps(testId, 'action-menu-button', 'testId')}
        />
      }
      popoverButtonProps={props}
    />
  );
};

export default TopbarActionMenu;
